import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { MeepCardPasswordModel } from '../components/input/rules/implementations/meepCardPassword.model';
import { MeepCardNameModel } from '../components/input/rules/implementations/meepCardName.model';

export class PasswordModel {
  senhaAtual: string;
  senhaNova: string;
  confirmarSenhaNova: string;

  cardName: string;
  cardNameConfirm: string;

  senhaAtualInputModel = new InputModel(false, false, 'password', 'Senha', [new RequiredModel]);
  senhaNovaInputModel = new InputModel(false, false, 'password', 'Nova senha', [new RequiredModel]);
  confirmarSenhaNovaInputModel = new InputModel(false, false, 'password', 'Confirme a nova senha', [new RequiredModel]);

  // tslint:disable-next-line:max-line-length
  meepCardSenhaNovaInputModel = new InputModel(false, false, 'password', 'Nova senha', [new MeepCardPasswordModel(), new RequiredModel], new MeepCardPasswordModel());
  // tslint:disable-next-line:max-line-length
  meepCardConfirmarSenhaNovaInputModel = new InputModel(false, false, 'password', 'Confirme a nova senha', [new MeepCardPasswordModel(), new RequiredModel], new MeepCardPasswordModel());

  // tslint:disable-next-line:max-line-length
  cardNameInputModel = new InputModel(false, false, 'text', 'Novo apelido', [new MeepCardNameModel(), new RequiredModel()], new MeepCardNameModel());
  // tslint:disable-next-line:max-line-length
  cardNameConfirmInputModel = new InputModel(false, false, 'text', 'Confirme o novo apelido', [new MeepCardNameModel(), new RequiredModel()], new MeepCardNameModel());

  constructor() {
    this.cardNameInputModel.setUpperCase();
    this.cardNameConfirmInputModel.setUpperCase();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/password.model.ts